import Header from "../header/Header";
import Footer from "../footer/Footer";
import HeroSection from "./HeroSection";
import StatsSection from "./StatsSection";
import WhyChooseUs from "./WhyChooseUs";
import ProgramsSection from "./ProgramsSection";
import TestimonialsSection from "./TestimonialsSection";
import BookingCTA from "./BookingCTA";
import ContactSection from "./ContactSection";

const LandingPage = () => {
  return (
    <div className="bg-[#0F172A] text-[#F8FAFC]">
      <Header />
      <main className="overflow-hidden">
        <HeroSection />
        <StatsSection />
        <WhyChooseUs />
        <ProgramsSection />
        <TestimonialsSection />
        <BookingCTA />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
